import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const SpellCheck2: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm6 16 6-12 6 12' }],
    ['path', { d: 'M8 12h8' }],
    [
      'path',
      {
        d: 'M4 21c1.1 0 1.1-1 2.3-1s1.1 1 2.3 1c1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1',
      },
    ],
  ],
];

export default SpellCheck2;
